import { Validators } from "@angular/forms"
import { IFormKey } from "src/app/modules/shared/models/forms"

export const single_step_branch_form_template = {
    line: ''
}

export const single_step_branch_form_validators = {
    line: [Validators.required]
}

export const single_step_branch_form_keys: IFormKey[] = [
    {
        id: 'line-field',
        label: 'Nuova linea investimento',
        controlName: 'line',
        css: 'col-8',
        type: 'SELECT',
        options: []
    }
]